import moment from "moment";

import { convertUtcToLocal } from "../../../Common/utils/dateUtils";

export const formatSubmissionDateTime = (dateValue) => {
  if (!dateValue) return "";
  return moment(new Date(convertUtcToLocal(dateValue))).format("DD MMM YYYY | hh:mm a");
};

export const formatActivityHistoryDateTime = (dateValue) => {
  if (!dateValue) return "";
  return moment(new Date(convertUtcToLocal(dateValue))).format("MMM D, YYYY • hh:mm A");
};

export const getTotalTestsDisplay = (submission) => {
  const completed = submission?.num_tests_with_due_date_or_results;
  const total = submission?.num_tests;

  if (
    (completed === null || completed === undefined || completed === "")
    && (total === null || total === undefined || total === "")
  ) {
    return "-";
  }

  if (total === null || total === undefined || total === "") {
    return String(completed ?? "-");
  }

  return `${completed ?? 0}/${total}`;
};

export const normalizeActivityHistoryItem = (item = {}) => ({
  title: item.company_domain || item.action || item.title || item.description || item.label || "Activity",
  user: (item.source === "SMS" || item.source === "sms" ? "Lab User" : item.action_by) || item.user || item.last_action_by || "-",
  date: item.action_at || item.date || item.action_on || item.timestamp || item.created_at || "",
});

export const getActivityHistoryItems = (submission) => (
  Array.isArray(submission?.activity_history)
    ? submission.activity_history.map(normalizeActivityHistoryItem)
    : []
);
